import { canDownloadSpaceFile, DataRoomAccessPermission, SpaceKind } from 'shared';

import { StringKey } from '../../../lang/index';
import { WorkspaceCardMenuAction } from '../types/data-room.types';

export type WorkspaceCardMenuItem = {
  action: WorkspaceCardMenuAction;
  isDestructive?: boolean;
  label: StringKey;
};

const DATA_ROOM_CARD_MENU_ITEMS: WorkspaceCardMenuItem[] = [
  { action: WorkspaceCardMenuAction.VIEW, label: 'VIEW_DATA_ROOM' },
  { action: WorkspaceCardMenuAction.SHARE_ACCESS, label: 'SHARE_ACCESS' },
  { action: WorkspaceCardMenuAction.SETTINGS, label: 'SETTINGS' },
  { action: WorkspaceCardMenuAction.DOWNLOAD, label: 'DOWNLOAD' },
  { action: WorkspaceCardMenuAction.DELETE, isDestructive: true, label: 'DELETE' },
];

/**
 * What somebody a room was shared with can do from its card: open it, and take it away when they
 * were given that. Share, settings and delete are the owner's, and are not shown rather than shown
 * and refused.
 */
const RECIPIENT_CARD_MENU_ITEMS: WorkspaceCardMenuItem[] = [
  { action: WorkspaceCardMenuAction.VIEW, label: 'VIEW_DATA_ROOM' },
  { action: WorkspaceCardMenuAction.DOWNLOAD, label: 'DOWNLOAD' },
];

const WORKSPACE_CARD_MENU_ITEMS: WorkspaceCardMenuItem[] = [
  { action: WorkspaceCardMenuAction.VIEW, label: 'VIEW_WORKSPACE' },
  { action: WorkspaceCardMenuAction.SETTINGS, label: 'SETTINGS' },
  { action: WorkspaceCardMenuAction.DOWNLOAD, label: 'DOWNLOAD' },
  { action: WorkspaceCardMenuAction.DELETE, isDestructive: true, label: 'DELETE' },
];

const CARD_MENU_ITEMS: Record<SpaceKind, WorkspaceCardMenuItem[]> = {
  [SpaceKind.DATA_ROOM]: DATA_ROOM_CARD_MENU_ITEMS,
  [SpaceKind.VAULT]: [],
  [SpaceKind.WORKSPACE]: WORKSPACE_CARD_MENU_ITEMS,
};

// 20.2.4.2: a Guest Auditor has no access to the sharing flow at all, regardless of toggle state,
// so the card does not offer its entry point.
export const getWorkspaceCardMenuItems = (
  kind: SpaceKind,
  { isAuditor = false }: { isAuditor?: boolean } = {},
): WorkspaceCardMenuItem[] =>
  isAuditor
    ? CARD_MENU_ITEMS[kind].filter(({ action }) => action !== WorkspaceCardMenuAction.SHARE_ACCESS)
    : CARD_MENU_ITEMS[kind];

/**
 * The same decision the server makes about the archive, taken from the same shared rule — so the
 * entry a recipient is offered is the request that will be answered, not one refused afterwards.
 */
export const getRecipientCardMenuItems = (
  permission: DataRoomAccessPermission,
): WorkspaceCardMenuItem[] =>
  RECIPIENT_CARD_MENU_ITEMS.filter(
    ({ action }) => action !== WorkspaceCardMenuAction.DOWNLOAD || canDownloadSpaceFile(permission),
  );
